import { AssetOwnerGetters } from '@/modules/assetOwner/store/getters';
import { AssetOwnerMutations } from '@/modules/assetOwner/store/mutations';
import {
  AssetOwnerState,
  IAssetOwnerState
} from '@/modules/assetOwner/store/state';
import { IRootState } from '@/store/state';
import { Module } from 'vuex';
import { AssetOwnerActions } from '@/modules/assetOwner/store/actions';

export const AssetOwnerModuleStore: IAssetOwnerModuleStore = {
  state: AssetOwnerState,
  actions: AssetOwnerActions,
  getters: AssetOwnerGetters,
  mutations: AssetOwnerMutations
};

/**
 * --------------------------------------------------
 *	AssetOwner Store Interface
 * --------------------------------------------------
 **/
export interface IAssetOwnerModuleStore
  extends Module<IAssetOwnerState, IRootState> {}
